module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg2@3x.4478873d.png";